import React from 'react';
import { Col, Row } from 'antd';

import type { BeraReportV2ResultStep, BeraReportV2StepKeyRow } from '@/types/Bera';

import { DetailCells } from './DetailCells';
import { StatusMark } from './StatusMark';
import { toStepKeyTitle } from '../utils';
import { RowBar, RowBarSlot, RowTitle } from './styles';

const STATUS_GUTTER = 16;
const DETAIL_GUTTER = 16;

interface StepKeyRowProps {
	step: BeraReportV2ResultStep;
	stepKey: BeraReportV2StepKeyRow;
}

export function StepKeyRow({ step, stepKey }: Readonly<StepKeyRowProps>): JSX.Element {
	const title = toStepKeyTitle(step, stepKey);

	return (
		<Row gutter={[0, DETAIL_GUTTER]}>
			<Col span={24}>
				<Row align="middle" gutter={[STATUS_GUTTER, 0]} wrap={false}>
					<Col>
						<StatusMark presence={stepKey.hasPresence} />
					</Col>
					<Col flex="auto">
						<RowTitle>{title}</RowTitle>
					</Col>
				</Row>
			</Col>
			<Col span={24}>
				<Row align="top" wrap={false}>
					<RowBarSlot>{!stepKey.hasPresence && <RowBar />}</RowBarSlot>
					<DetailCells stepKey={stepKey} />
				</Row>
			</Col>
		</Row>
	);
}
